import { z } from 'zod';

export const ExchangeSchema = z.object({
	assets: z
		.array(
			z.object({
				cc1: z.boolean(),
				cc2: z.boolean(),
				ethereum: z.boolean(),
				shortCode: z.string()
			})
		)
		.default([]),
	code: z.string(),
	name: z.string()
});

export type ExchangeSchemaType = z.infer<typeof ExchangeSchema>;
